'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { LandingImageTextStoryblok } from 'storyblok-types';
import { Picture } from 'atoms/Picture';
import { H3 } from 'atoms/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import styles from './styles.module.css';

export const LandingImageText: FC<{ blok: LandingImageTextStoryblok }> = ({
  blok,
}) => {
  return (
    <div className={clsx(styles.root, styles[blok.image_position || 'left'])}>
      <Picture
        srcDesktop={blok.image_desktop}
        srcMobile={blok.image_mobile}
        className={styles.image}
      />
      <div className={styles.text}>
        <RichTextMarkdown
          text={blok.text}
          components={{
            h3: ({ children }) => <H3 className={styles.title}>{children}</H3>,
          }}
        />
      </div>
    </div>
  );
};
